/* eslint-disable no-unused-vars */
import { Modal, Spin, Tabs } from "antd";
import React, { Suspense, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import {
  getDrivingLicenseCapabilityTypesList,
  getSiteListData,
  getTagsList,
  identificationNameList,
  qualificationTitleList
} from "@redux/actionCreators";

import DetailedPersonSearch from "./ui/detailed-person-search";
import { DraggableTitle, DraggableWrapper } from "@ui/modals/draggable-wrapper";
import Loader from "@app/layout/page-loader";
import GlobalSearch from "./ui/global-search";
import DetailedSiteSearch from "./ui/detailed-site-search";
import DetailedRefereeSearch from "./ui/detailed-referee-search";

import constants from "@constants/constants";
import { GLOBAL_SEARCH_TABS, globalSearchTabs } from "./constants";

import "./global-search-modal.scss";
import "@assets/styles/modal.scss";

const { MODAL_ZINDEX, NULLIFY } = constants;

const { TabPane } = Tabs;

const GlobalSearchModal = ({ isVisible, modalHeader, resetModalFn, width = "", searchString }) => {
  const dispatch = useDispatch();

  const candidateModalReducer = useSelector(rdc => rdc?.candidateModalReducer, shallowEqual);

  const {
    getGlobalSearch: { isLoading = false }
  } = candidateModalReducer;

  useEffect(() => {
    dispatch(getSiteListData());
    dispatch(getTagsList());
    dispatch(getDrivingLicenseCapabilityTypesList());
    dispatch(qualificationTitleList());
    dispatch(identificationNameList());
  }, []);

  return (
    <Modal
      title={<DraggableTitle title={modalHeader} />}
      modalRender={modal => <DraggableWrapper>{modal}</DraggableWrapper>}
      open={isVisible}
      footer={NULLIFY}
      zIndex={MODAL_ZINDEX}
      onCancel={resetModalFn}
      maskClosable={false}
      width={width}
      centered
      destroyOnClose
      className="drs-modal-css"
    >
      <Spin spinning={isLoading}>
        <Tabs defaultActiveKey="Profile" className="details-all-tabs">
          {[...globalSearchTabs].map(({ label, value }) => (
            <TabPane tab={`${label}`} key={value}>
              <Suspense fallback={<Loader />}>
                {value === GLOBAL_SEARCH_TABS.GLOBAL && (
                  <GlobalSearch searchString={searchString} />
                )}

                {value === GLOBAL_SEARCH_TABS.DETAIL_PERSON && <DetailedPersonSearch />}

                {value === GLOBAL_SEARCH_TABS.DETAIL_SITE && <DetailedSiteSearch />}

                {value === GLOBAL_SEARCH_TABS.DETAIL_REFEREE && <DetailedRefereeSearch />}
              </Suspense>
            </TabPane>
          ))}
        </Tabs>
      </Spin>
    </Modal>
  );
};

export default React.memo(GlobalSearchModal);
